export const SessionConstants = {
  SCROLL_STORAGE_KEY: "SCROLL_STORAGE_KEY",
  PENDING_MAIN_GRID_SCROLL_SYNC_KEY: "PENDING_MAIN_GRID_SCROLL_SYNC_KEY",
}